var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasProjects)?_c('report-not-configured-instance'):_c('vulnerability-report-tabs')
}
var staticRenderFns = []

export { render, staticRenderFns }